<template>
  <b-container>
    <template v-if="!roleTypeId">
      <indica-list
        table-name="RoleType"
        :override-fields="['name']"
        @onRowClick="setRoleTypeId"
      />
    </template>
    <template v-if="roleTypeId">
      <indica-form
        table-name="RoleType"
        :id-to-edit="roleTypeId"
        :show-many="false"
      />
      <indica-checkbox-hierarchy
        left-header="Granted Permissions"
        right-header="Available Permissions"
        table-name="RoleType"
        :current-id="roleTypeId"
        many-table-name="Permissions"
        :refresh="refreshPermissions"
        @retrieveData="retrievePermissions"
      />
    </template>

    <!--    <form-wizard ref="wizard" title="Permissions Assignation to Role Type" subtitle="" color="#1e4380" shape="tab">
      <template v-slot:next="data"><span></span></template>
      <template v-slot:finish="data"><span></span></template>
      <tab-content title="Role Type">

        <div class="explanationText">Seleccione el role type al cual desea brindar o revocar permisos.</div>

        <b-tabs>

        </b-tabs>
      </tab-content>
      <tab-content title="Permissions">
        <div class="explanationText">
          Seleccione y arrastre los permisos que desea brindar al role type <b v-if="roleType"> {{roleType.name}}</b>
        </div>
        &lt;!&ndash;<b-container>
          <b-row>
            <b-col>&ndash;&gt;

        &lt;!&ndash;<draggable v-model="revokePermissionsArray" v-bind="dragOptions" :move="onMove"
                   @start="isDragging=true"
                   @end="isDragging=false">
          <div v-for="element in [{id:2,name:2}]" :key="element.id">{{element.name}}</div>
        </draggable>&ndash;&gt;
        &lt;!&ndash;              <b-container>
                        <b-row>
                          <b-col cols="6">
                            <div>
                              <draggable class="list-group" :list="grantPermissionsArray" group="people" @change="log">
                                <div
                                  class="list-group-item"
                                  v-for="(element, index) in grantPermissionsArray"
                                  :key="element.name"
                                >
                                  {{ element.name }}
                                </div>
                              </draggable>
                            </div>
                          </b-col>
                          <b-col cols="6">
                            <draggable class="list-group" :list="revokePermissionsArray" group="people" @change="log">
                              <div
                                class="list-group-item"
                                v-for="(element, index) in revokePermissionsArray"
                                :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </b-col>
                        </b-row>
                      </b-container>&ndash;&gt;
        &lt;!&ndash;
                      <draggable v-if="readyPermissions" v-model="revokePermissionsArray" v-bind="dragOptions" :move="onMove"
                                 @start="isDragging=true"
                                 @end="isDragging=false">
                        <div v-for="element in revokePermissionsArray" :key="element.id">{{element.name}}</div>
                      </draggable>&ndash;&gt;


        &lt;!&ndash;            </b-col>
                    <b-col>
                      <indica-list table-name="PermissionModule"
                                   :override-fields="['Check','name']"
                      ></indica-list>
                    </b-col>&ndash;&gt;
        &lt;!&ndash;<b-col>
          <indica-form @refresh="refreshDataPermissions" table-name="Permission"></indica-form>
        </b-col>&ndash;&gt;
        &lt;!&ndash;          </b-row>
                </b-container>&ndash;&gt;
      </tab-content>
      &lt;!&ndash;      <tab-content title="Account Role Template">
              <b-tabs>
                <b-tab title="New Account Role Template" active>
                  <indica-form table-name="AccountRoleTemplate" @refresh="accountRoleTemplateCreated"
                               :pre-filled-values="preFillRoleTemplate"></indica-form>
                </b-tab>
                <b-tab title="View Existing Account Role Template">
                  <indica-list table-name="AccountRoleTemplate" @edit="setaccountRoleTemplateId"
                               :filter="roleTypeTemplateFilter" :override-fields="['Select','roleTypeId','name']"></indica-list>
                </b-tab>
              </b-tabs>
            </tab-content>
            <tab-content title="Tags">
              <b-tabs>
                <b-tab title="New Tag" active>
                  <indica-form table-name="Tag" @refresh="tagCreated"></indica-form>
                </b-tab>
                <b-tab title="Existing Tag">
                  <indica-list table-name="Tag"
                               @edit="setTagId" :override-fields="['Select','name']"></indica-list>
                </b-tab>
              </b-tabs>
            </tab-content>
            <tab-content title="Country">
              <b-tabs>
                <b-tab title="New Country" active>
                  <indica-form table-name="Country" @refresh="countryCreated"></indica-form>
                </b-tab>
                <b-tab title="Existing Country">
                  <indica-list table-name="Country"
                               @edit="setCountryId"></indica-list>
                </b-tab>
              </b-tabs>
            </tab-content>
            <tab-content title="Access Control Template">
              <div>
                <span v-if="accountRoleTemplate">Account Role Template {{accountRoleTemplate.name}}</span> -
                <span v-if="roleType">Based on {{roleType.name}} </span>
              </div>
              <div v-if="permissions">
                <div v-for="(permission,indexP) in permissions">
                  <div>{{permission.name}}</div>
                  <div>{{permission.description}}</div>
                  <div>{{permission.endpoint}}</div>
                  <div>{{permission.method}}</div>
                </div>
              </div>
              <div v-if="tag">Ruled by Tag {{tag.name}}</div>
              <div v-if="country">Ruled by Country {{country.country}}</div>
              <div @click="createAccessControlTemplate()" style="border: 1px solid red; cursor:pointer">Create New Access Control Template</div>
            </tab-content>
            <tab-content title="Success">

            </tab-content>&ndash;&gt;
    </form-wizard>-->
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import IndicaList from "../../../utils/forms/indica-list";
import IndicaForm from "../../../utils/forms/indica-form";
import { axiosCall } from "../../../utils/axiosCall";
import { GetTableDataByName } from "../../../utils/forms/tablesConfiguration";
import IndicaCheckboxHierarchy from "../../../utils/forms/indica-checkbox-hierachy";

export default {
  name: "ConfigurationWizard",
  components: {
    IndicaCheckboxHierarchy,
    IndicaList,
    IndicaForm,
  },
  data() {
    return {
      refreshPermissions: 0,
      roleTypeId: null,
      tagId: null,
      countryId: null,
      accessControlTemplateId: null,
      country: null,
      accountRoleTemplateId: null,
      preFillRoleTemplate: [],
      roleType: null,
      permissions: null,
      accountRoleTemplate: null,
      tag: null,
      roleTypeTemplateFilter: null,
      revokePermissionsArray: [],
      grantPermissionsArray: [],
      readyPermissions: false,
      list1: [],
      list2: [],
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "permissions",
        disabled: !this.editable,
        ghostClass: "ghostPermission",
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    add: function () {
      this.list.push({ name: "Juan" });
    },
    replace: function () {
      this.list = [{ name: "Edgard" }];
    },
    clone: function (el) {
      return {
        name: el.name + " cloned",
      };
    },
    log: function (evt) {
      window.console.log(evt);
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    retrievePermissions(permissions) {
      this.permissions = permissions.filter(
        (permission) => permission.status === true
      );
    },
    refreshDataPermissions() {
      this.refreshPermissions++;
    },
    getPermissionsList: async function () {
      this.readyPermissions = false;
      await axiosCall({ url: `Permissions`, method: "get" }).then(
        async (response) => {
          const where = {};
          where["where"] = {};
          where["where"]["roleTypeId"] = this.roleTypeId;
          await axiosCall({
            url: `PermissionRoleTypes?filter=` + JSON.stringify(where),
            method: "get",
          }).then((responseG) => {
            var grantedPermissions = responseG.data.map(
              (permission) => permission.permissionId
            );
            this.grantPermissionsArray = response.data.filter((permission) =>
              grantedPermissions.includes(permission.customId)
            );
            this.revokePermissionsArray = response.data.filter(
              (permission) => !grantedPermissions.includes(permission.customId)
            );
          });
          this.readyPermissions = true;
        }
      );
    },
    accountRoleTemplateCreated(data) {
      this.setaccountRoleTemplateId(data.id);
    },
    roleTypeCreated(data) {
      this.setRoleTypeId(data.id);
    },
    setRoleTypeId: async function (roleTypeRow) {
      const tableData = GetTableDataByName("RoleType");
      this.roleTypeId = roleTypeRow[tableData.idName];
      this.preFillRoleTemplate.push({
        name: "roleTypeId",
        value: this.roleTypeId,
      });
      await axiosCall({
        url: `RoleTypes/${this.roleTypeId}`,
        method: "get",
      }).then((response) => {
        this.roleType = response.data;
        this.$forceUpdate();
      });
      const where = {};
      where["where"] = {};
      where["where"]["roleTypeId"] = this.roleTypeId;
      this.roleTypeTemplateFilter = where;
      await this.getPermissionsList();
      this.$refs.wizard.nextTab();
    },
    setaccountRoleTemplateId: async function (accountRoleTemplateId) {
      this.accountRoleTemplateId = accountRoleTemplateId;
      await axiosCall({
        url: `accountRoleTemplates/${accountRoleTemplateId}`,
        method: "get",
      }).then((response) => {
        this.accountRoleTemplate = response.data;
      });
      this.$refs.wizard.nextTab();
    },
    createAccessControlTemplate: async function () {
      const data = {
        ruleByTagId: this.tagId,
        ruleByCountryId: this.countryId,
        accountRoleTemplateId: this.accountRoleTemplateId,
      };
      await axiosCall({ url: `AccessControlTemplates`, method: "post", data })
        .then((response) => {
          this.accountRoleTemplate = response.data;
        })
        .then(() => {
          this.$refs.wizard.nextTab();
        });
    },
    tagCreated(data) {
      this.setTagId(data.id);
    },
    setTagId: async function (tagId) {
      this.tagId = tagId;
      await axiosCall({ url: `Tags/${tagId}`, method: "get" }).then(
        (response) => {
          this.tag = response.data;
        }
      );
      this.$refs.wizard.nextTab();
    },
    accessControlTemplateCreated(data) {
      this.setAccessControlTemplateId(data.id);
    },
    setAccessControlTemplateId: async function (accessControlTemplateId) {
      this.accessControlTemplateId = accessControlTemplateId;
      this.$refs.wizard.nextTab();
    },
    countryCreated(data) {
      this.setCountryId(data.id);
    },
    setCountryId: async function (countryId) {
      this.countryId = countryId;
      await axiosCall({ url: `Countries/${countryId}`, method: "get" }).then(
        (response) => {
          this.country = response.data;
        }
      );
      this.$refs.wizard.nextTab();
    },
  },
};
</script>

<style lang="scss" scoped>
.explanationText {
  padding: 30px 0;
}
</style>
